// extracted by mini-css-extract-plugin
export default {"mainHeadinstyle":"brand-module_mainHeadinstyle__lm5N-","privacyWrapper":"brand-module_privacyWrapper__T3Wnb","privacysubHeading":"brand-module_privacysubHeading__W6kMM"};